import { render, staticRenderFns } from "./TMNErrorPage.vue?vue&type=template&id=cdbbfd54&"
import script from "./TMNErrorPage.vue?vue&type=script&lang=js&"
export * from "./TMNErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports